import { EnrichedVideoEditorEditListItemDto } from '@app/modules/video-editions/types';

/**
 * Whether an edit can start a deferred social publish: a render job exists and is not
 * FAILED or CANCELLED (pending or completed). Drafts with no render stay blocked.
 */
export function isVideoEditorEditSocialPublishable(
  edit: EnrichedVideoEditorEditListItemDto,
): boolean {
  const status = edit.renderJob?.status;
  if (!status) return false;
  return status !== 'FAILED' && status !== 'CANCELLED';
}
